import $ from 'jquery';

export default class {
	constructor(options) {
		const defaults = {
			el: '#headerUser',
			classes: {
				hover: 'b-header-user_state_hover'
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		return this;
	}

	onMouseEnter() {
		const self = this;
		if (!self.$el.hasClass(self.options.classes.hover)) {
			clearTimeout(self.enterTimeout);
			clearTimeout(self.leaveTimeout);
			self.enterTimeout = setTimeout(function () {
				self.$el.addClass(self.options.classes.hover);
			}, 250);
		}
	}

	onMouseLeave() {
		const self = this;
		if (self.$el.hasClass(self.options.classes.hover)) {
			clearTimeout(self.enterTimeout);
			clearTimeout(self.leaveTimeout);
			self.leaveTimeout = setTimeout(function () {
				self.$el.removeClass(self.options.classes.hover);
			}, 250);
		}
	}

	render() {
		if (this.$el.length) {
			this.$el
				.on('mouseleave', this.onMouseLeave.bind(this))
				.on('mouseenter', this.onMouseEnter.bind(this));
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/partials/site/header/user/user.js